<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Detail Username POS</CCardHeader>
        <CCardBody class="ml-4">
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="POS Code"
                class="mb-0"
                type="text"
                required
                vertical
                disabled
                v-model="dataUsernamePOS.pos_code"
                placeholder="POS Code"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Username"
                class="mb-0"
                type="text"
                required
                vertical
                v-model="dataUsernamePOS.username"
                :disabled="isDetail"
                placeholder="Username Name"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Created At"
                class="mb-0"
                type="text"
                required
                vertical
                v-if="isDetail"
                v-model="dataUsernamePOS.created_at"
                :disabled="isDetail"
                placeholder="Created At"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Updated At"
                class="mb-0"
                type="text"
                required
                vertical
                v-if="isDetail"
                v-model="dataUsernamePOS.updated_at"
                :disabled="isDetail"
                placeholder="Updated At"
              />
            </CCol>
          </CRow>
          <CRow class="btn-member-pos">
            <CButton color="primary" @click="goBack">Back</CButton>
            <CButton v-if="!isDetail" color="success" @click="update"
              >Update</CButton
            >
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";
import moment from "moment";
import Swal from "sweetalert2";
export default {
  components: {
  },
  name: "MemberPOS",
  data() {
    return {
      dataUsernamePOS: {},
      dataUsernameUpdate: {
        username: "",
      },
      isDetail: false,
      domain: process.env.VUE_APP_DOMAIN_URL,
      options: ["ACTIVE", "INACTIVE"],
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
 
  beforeMount() {
    this.authentication();
    if (this.$router.currentRoute.path.includes("username/detail")) {
      this.isDetail = true;
    } else if (this.$router.currentRoute.path.includes("username/edit")) {
      this.isDetail = false;
    }
    this.getUsernamePOSData();
  },
  methods: {
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "NPOS" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    getUsernamePOSData() {
      axios
        .get(
          `${this.domain}/v1/pos/username/${this.$route.params.usernamePOSID}`,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.dataUsernamePOS = response.data;
          this.dataUsernamePOS.created_at = moment(
            this.dataUsernamePOS.created_at
          ).format("MM/DD/YYYY HH:mm:ss");
          this.dataUsernamePOS.updated_at = moment(
            this.dataUsernamePOS.updated_at
          ).format("MM/DD/YYYY HH:mm:ss");
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Gagal mendapatkan data username POS",
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },
    update() {
      this.dataUsernameUpdate.username = this.dataUsernamePOS.username
      axios
        .put(
          `${this.domain}/v1/pos/username/${this.dataUsernamePOS.id}`,
          this.dataUsernameUpdate,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Data member POS diupdate",
            showConfirmButton: false,
            timer: 2000,
          });
          this.$router.push(`/management/member-pos/edit/${this.$route.params.memberPOSID}`)
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Gagal update data username POS",
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },
    goBack() {
      this.$router.push(
        `/management/member-pos/edit/${this.$route.params.memberPOSID}`
      );
    },
  },
};
</script>

<style scoped>
@import url("./MemberPOS.css");
</style>



